import React from 'react';

import { Icon } from '@shared/ui/components/Icon';

export default function TimerIcon() {
  return (
    <>
      <div className="clock text-white"></div>
    </>
  );
}
